export default __webpack_public_path__ + "static/media/home-yoga-meditation-popular-classes-img01.740ee46f.jpg";